import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import type { JSX } from 'react';

import AttentionIcon from 'app/assets/icons/attention.svg?react';
import { PrimaryButton } from 'app/shared-components/buttons';

type ErrorStateProps = {
  title?: string;
  subtitle?: string;
  link?: {
    label: string;
    href: string;
    replace?: boolean;
  };
  action?: {
    label: string;
    onClick: () => void;
  };
};

export default function ErrorState({
  title = 'An error occurred',
  subtitle = 'Please try again later',
  link,
  action,
}: ErrorStateProps): JSX.Element {
  return (
    <Box className="my-24 flex flex-col text-center items-center gap-6">
      <AttentionIcon />
      <Typography className="font-500 text-14 text-typography-secondary">{title}</Typography>
      {subtitle && (
        <Typography className="font-400 text-12 text-typography-thirty">{subtitle}</Typography>
      )}
      {link && (
        <Link to={link.href} replace={link.replace ?? false}>
          {link.label}
        </Link>
      )}
      {action && <PrimaryButton label={action.label} cb={action.onClick} size="m" />}
    </Box>
  );
}
